import { useEffect } from "react";
import useCommandFlowStore from "../../store/commandFlowStore";

export const useThemeManager = (themeProp) => {
  const { theme, setTheme } = useCommandFlowStore();

  useEffect(() => {
    if (themeProp && themeProp !== theme) {
      setTheme(themeProp);
    }
  }, [themeProp, theme, setTheme]);

  return theme;
};
